import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n";

const LanguageContext = createContext(null);
const STORAGE_KEY = "saubereko_lang";
const SUPPORTED = ["sk", "en", "de", "pl", "fr"];

const detectLang = () => {
  if (typeof navigator === "undefined") return "sk";
  const cands = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
  for (const c of cands) {
    const code = String(c).slice(0, 2).toLowerCase();
    if (code === "cs") return "sk";
    if (SUPPORTED.includes(code)) return code;
  }
  return "sk";
};

const initialLang = () => {
  if (typeof window === "undefined") return "sk";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (SUPPORTED.includes(saved)) return saved;
  return detectLang();
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.en || translations.sk;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
